import { Button, Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import type { SettlementRoot2 } from '@repo/sdk'

import { StatusBadge } from '../../components/StatusBadge'
import { formatKrw } from '@repo/shared'
import { useOrderBriefStatusConfig } from './orderBriefStatusConfig'
import { formatOrderBriefLabel } from '../orders/orderDisplay'
import { OrderTypeBadge } from '../orders/OrderTypeBadge'

interface SettlementOrderInfoCardProps {
  settlement: SettlementRoot2
}

export function SettlementOrderInfoCard({ settlement }: SettlementOrderInfoCardProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const orderStatusConfig = useOrderBriefStatusConfig()
  const { order } = settlement

  return (
    <Card title={t('pages.settlements.sections.orderInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('common.columns.orderId')}>
          <Button
            data-testid="settlement-detail-order-link"
            type="link"
            size="small"
            style={{ padding: 0 }}
            onClick={() => void navigate(`/orders/${order.fulfillmentOrderId}`)}
          >
            {formatOrderBriefLabel(order)}
          </Button>
        </Descriptions.Item>
        <Descriptions.Item label={t('common.columns.orderType')}>
          <OrderTypeBadge orderType={order.orderType} saleType={order.saleType} />
        </Descriptions.Item>
        <Descriptions.Item label={t('common.columns.orderStatus')}>
          <StatusBadge status={order.orderStatus} configMap={orderStatusConfig} />
        </Descriptions.Item>
        <Descriptions.Item label={t('common.columns.totalPaymentAmount')}>
          {formatKrw(order.totalAmount)}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
